import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import LogoImage from "../../assets/images/logo.png";
import NavImage from "../../assets/images/nav.png";
import {Link, NavLink, useLocation} from "react-router-dom";
import produce from "immer";

const Container = styled.div`
  width: 270px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: bottom;
  background-position-x: right;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  background-color: #016562;
`;
const Logo = styled.img`
  width: 93px;
  height: 30px;
  margin: 15px 15px;
`;
const Menus = styled.div`
  text-align: left;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;
const Menu = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 16px;
  height: 48px;
  cursor: pointer;

  & > div {
    transition: all 0.3s;
  }

  &.active {
    background-color: #005B57;

    span {
      color: #fff !important;
    }

    & > div {
      transform: rotate(180deg);
    }
  }
`;

const MenuView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 16px;
  height: 48px;
  cursor: pointer;

  & > div {
    transition: all 0.3s;
  }

  &.active {
    background-color: #005B57 !important;
  }

  &.expand {
    span {
      color: #fff !important;
    }

    & > div {
      transform: rotate(180deg);
    }
  }
`;


const MenuGroup = styled.div`
  height: 48px;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;

  &.expand {
    height: auto;
  }

  &.collapse {
    overflow: inherit;

    & .sub-menu {
      display: none;
    }
  }

  &.collapse:hover .sub-menu {
    display: block;
    position: absolute;
    background-color: #036562;
    left: 46px;
    top: 0;
    width: 150px;
    border-radius: 4px;
    overflow: hidden;
  }

`;
const MenuIcon = styled.span`
  line-height: 15px;
  color: #fff;
  margin-right: 10px;
`;
const MenuText = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 48px;
  color: #F2EDD4;
  flex: 1;
`;
const MenuArrow = styled.div`
  line-height: 20px;
  color: #98989A;

  & > svg {
    width: 15px;
  }
`;
const ArrowIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 21px;
  z-index: 1;
  cursor: pointer;
  transition: all 0.3s;

  & > svg {
    width: 23px;
    transition: all 0.3s;
  }
`;
const MenuLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding-left: 42px;
  height: 46px;
  width: 100%;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 36px;
  color: #F2EDD4;


  //&:before {
  //  content: "";
  //  position: absolute;
  //  left: 32px;
  //  top: 22px;
  //  width: 3px;
  //  height: 3px;
  //  background-color: #F2EDD4;
  //}

  &.active {
    color: #fff;
    background: #307870;
  }
`;

export default function Sidebar({onExpand, expand}: any) {
    const location = useLocation();
    const [expands, setExpands] = useState<Array<string>>([]);

    useEffect(() => {
        if (hasActive('user') && !expands.includes('user')) {
            setExpands(produce(draft => {
                draft.push('user');
            }))
        }
        if (hasActive('trail') && !expands.includes('trail')) {
            setExpands(produce(draft => {
                draft.push('trail');
            }))
        }
    }, [location.pathname, expand])

    const hasActive = (path: string) => {
        return location.pathname.includes(path);
    }

    const onMenuExpand = (name: string) => {
        if (expands.includes(name)) {
            setExpands(produce(draft => {
                draft.splice(draft.findIndex(item => item === name), 1);
            }))
        } else {
            setExpands(produce(draft => {
                draft.push(name);
            }))
        }
    }


    return (
        <Container>
            <Logo src={LogoImage} style={{opacity: expand ? 1 : 0}}/>
            <ArrowIcon onClick={() => onExpand()}>
                <svg style={{transform: `rotate(${expand ? '0' : '180'}deg)`}} width="25" height="20"
                     viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="25" y1="14.75" x2="9" y2="14.75" stroke="#F2EDD4" strokeWidth="1.5"/>
                    <line x1="25" y1="7.75" x2="1" y2="7.75" stroke="#F2EDD4" strokeWidth="1.5"/>
                    <line x1="25" y1="0.75" x2="1" y2="0.750002" stroke="#F2EDD4" strokeWidth="1.5"/>
                    <path d="M6 11L2 15L6 19" stroke="#F2EDD4" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
            </ArrowIcon>
            <Menus>


                <MenuGroup>
                    <Menu to={"/resources"}>
                        <MenuIcon>
                            <svg width="14" height="20" viewBox="0 0 14 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.9644 4.93079C13.9644 4.79611 13.8753 4.66143 13.7507 4.57164L12.5041 3.64385L8.31898 0.755706L7.37511 0.112233C7.1436 -0.0374112 6.82304 -0.0374112 6.60934 0.112233L5.66547 0.755706L1.48039 3.61392L0.215966 4.49682C0.0734955 4.60157 -0.0155508 4.73625 0.00225799 4.90086V5.23008V5.84362V8.95623V11.3505V11.3655L1.48039 12.3681L5.66547 15.2263L6.03945 15.4807V19.177V19.1919V19.2069C6.03945 19.3565 6.09288 19.4912 6.18192 19.6109C6.3422 19.8504 6.66276 20 7.00113 20C7.51759 20 7.92719 19.6558 7.96281 19.2368C7.96281 19.2219 7.96281 19.1171 7.96281 19.1021V15.4807L8.33679 15.2263L12.5219 12.3681L14 11.3655V11.3505V8.95623V5.84362V5.3049L13.9644 4.93079ZM12.3616 10.5574C12.3616 10.722 12.2725 10.8717 12.1301 10.9615L8.94229 13.0116C8.53269 13.266 7.96281 13.0266 7.96281 12.6076V11.2757C7.96281 11.156 8.01623 11.0513 8.08747 10.9615L10.4382 8.41751C10.6341 8.19304 10.5985 7.87879 10.3314 7.69922L9.92178 7.42986C9.65465 7.25028 9.3519 7.29518 9.12038 7.50468C8.69297 7.86382 7.96281 8.97119 7.96281 8.47737V4.48186C7.96281 4.19753 7.69568 3.97306 7.35731 3.97306H6.66276C6.32439 3.97306 6.05726 4.19753 6.05726 4.48186V8.47737C6.05726 8.97119 5.3271 7.92368 4.9175 7.54957C4.68598 7.34007 4.36542 7.23532 4.09829 7.42986L3.68869 7.69922C3.42156 7.87879 3.38594 8.19304 3.59964 8.41751L5.95041 10.9615C6.03945 11.0513 6.07507 11.156 6.07507 11.2757V12.6076C6.07507 13.0415 5.48738 13.281 5.09558 13.0116L1.67629 10.8118V11.0363V5.39469C1.67629 5.23008 1.76533 5.08044 1.90781 4.99065L6.66276 1.89301C6.87647 1.74336 7.19703 1.74336 7.41073 1.89301L12.1657 4.99065C12.3082 5.0954 12.3972 5.24504 12.3972 5.39469L12.3616 10.5574Z"
                                    fill="white"/>
                            </svg>
                        </MenuIcon>
                        <MenuText style={{display: expand ? "block" : 'none'}}>Liên kết</MenuText>
                        <MenuArrow/>
                    </Menu>
                </MenuGroup>

                <MenuGroup>
                    <Menu to={"/responses"}>
                        <MenuIcon>
                            <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.7925 14H10.7487C10.5796 13.9905 10.4167 13.9325 10.2796 13.8329C10.1426 13.7333 10.0371 13.5964 9.97573 13.4385L6.05253 3.14191L4.00342 7.65579C3.93365 7.808 3.82168 7.937 3.68079 8.02748C3.5399 8.11796 3.37601 8.16612 3.20857 8.16624H0.875064C0.642983 8.16624 0.420407 8.07405 0.2563 7.90994C0.092194 7.74583 0 7.52326 0 7.29118C0 7.05909 0.092194 6.83652 0.2563 6.67241C0.420407 6.50831 0.642983 6.41611 0.875064 6.41611H2.64707L5.3306 0.509431C5.4025 0.353099 5.51889 0.221434 5.66522 0.130902C5.81155 0.0403709 5.98133 -0.00500877 6.15332 0.000438768C6.3253 0.00588631 6.49187 0.0619193 6.63218 0.16153C6.77249 0.261141 6.88031 0.399908 6.94217 0.560476L10.9018 10.9519L12.9291 6.8974C13.0026 6.75339 13.1142 6.63234 13.2518 6.54747C13.3894 6.46259 13.5477 6.41715 13.7093 6.41611H16.0428C16.2749 6.41611 16.4975 6.50831 16.6616 6.67241C16.8257 6.83652 16.9179 7.05909 16.9179 7.29118C16.9179 7.52326 16.8257 7.74583 16.6616 7.90994C16.4975 8.07405 16.2749 8.16624 16.0428 8.16624H14.249L11.5727 13.5187C11.4992 13.6627 11.3876 13.7838 11.25 13.8686C11.1124 13.9535 10.9541 13.999 10.7925 14Z"
                                    fill="white"/>
                            </svg>
                        </MenuIcon>
                        <MenuText style={{display: expand ? "block" : 'none'}}>Dữ liệu</MenuText>
                        <MenuArrow/>
                    </Menu>
                </MenuGroup>

                <MenuGroup>
                    <Menu to={"/settings"}>
                        <MenuIcon>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.63264 5.09389C6.16479 5.09389 5.72668 5.2754 5.39496 5.60712C5.06481 5.93883 4.88174 6.37695 4.88174 6.8448C4.88174 7.31264 5.06481 7.75076 5.39496 8.08248C5.72668 8.41263 6.16479 8.5957 6.63264 8.5957C7.10049 8.5957 7.5386 8.41263 7.87032 8.08248C8.20047 7.75076 8.38354 7.31264 8.38354 6.8448C8.38354 6.37695 8.20047 5.93883 7.87032 5.60712C7.7083 5.44385 7.51546 5.31441 7.30298 5.2263C7.09051 5.1382 6.86265 5.09319 6.63264 5.09389ZM13.0839 8.77877L12.0606 7.9041C12.1091 7.60681 12.1341 7.30326 12.1341 7.00127C12.1341 6.69928 12.1091 6.39416 12.0606 6.09843L13.0839 5.22376C13.1612 5.15759 13.2165 5.06945 13.2425 4.97106C13.2685 4.87268 13.264 4.76871 13.2294 4.67299L13.2154 4.63231C12.9337 3.84478 12.5117 3.11479 11.9698 2.47771L11.9417 2.44485C11.8759 2.36748 11.7882 2.31186 11.6901 2.28532C11.5921 2.25879 11.4883 2.26258 11.3925 2.2962L10.1219 2.7484C9.65252 2.36349 9.12991 2.05993 8.56349 1.8487L8.31783 0.520264C8.29929 0.420189 8.25075 0.328122 8.17864 0.256295C8.10653 0.184468 8.01428 0.136281 7.91413 0.118135L7.87189 0.110312C7.05824 -0.0367705 6.20078 -0.0367705 5.38714 0.110312L5.34489 0.118135C5.24474 0.136281 5.15249 0.184468 5.08038 0.256295C5.00828 0.328122 4.95973 0.420189 4.9412 0.520264L4.69397 1.85496C4.13291 2.06788 3.61025 2.37069 3.14648 2.75153L1.86655 2.2962C1.77074 2.26231 1.66688 2.25839 1.56878 2.28494C1.47068 2.31149 1.38298 2.36726 1.31734 2.44485L1.28918 2.47771C0.748247 3.11547 0.32637 3.84527 0.0436726 4.63231L0.0295902 4.67299C-0.0408214 4.86858 0.0170727 5.08764 0.175108 5.22376L1.21094 6.10782C1.16244 6.40199 1.13897 6.70241 1.13897 6.9997C1.13897 7.30013 1.16244 7.60055 1.21094 7.89159L0.178237 8.77564C0.100934 8.84182 0.0456072 8.92996 0.0196136 9.02835C-0.00637996 9.12673 -0.00180874 9.2307 0.0327196 9.32642L0.046802 9.3671C0.330013 10.1541 0.747789 10.8817 1.29231 11.5217L1.32047 11.5546C1.38627 11.6319 1.47397 11.6875 1.57202 11.7141C1.67006 11.7406 1.77384 11.7368 1.86968 11.7032L3.14961 11.2479C3.61589 11.6312 4.13537 11.9348 4.6971 12.1445L4.94433 13.4791C4.96286 13.5792 5.0114 13.6713 5.08351 13.7431C5.15562 13.8149 5.24787 13.8631 5.34802 13.8813L5.39027 13.8891C6.21192 14.037 7.05337 14.037 7.87502 13.8891L7.91726 13.8813C8.01741 13.8631 8.10966 13.8149 8.18177 13.7431C8.25388 13.6713 8.30242 13.5792 8.32096 13.4791L8.56661 12.1507C9.13304 11.9379 9.65565 11.6359 10.1251 11.251L11.3956 11.7032C11.4914 11.7371 11.5953 11.741 11.6934 11.7145C11.7915 11.6879 11.8792 11.6321 11.9448 11.5546L11.973 11.5217C12.5175 10.8786 12.9353 10.1541 13.2185 9.3671L13.2326 9.32642C13.2998 9.1324 13.2419 8.9149 13.0839 8.77877ZM6.63264 9.59555C5.11331 9.59555 3.88189 8.36413 3.88189 6.8448C3.88189 5.32547 5.11331 4.09405 6.63264 4.09405C8.15197 4.09405 9.38339 5.32547 9.38339 6.8448C9.38339 8.36413 8.15197 9.59555 6.63264 9.59555Z"
                                    fill="white"/>
                            </svg>
                        </MenuIcon>
                        <MenuText style={{display: expand ? "block" : 'none'}}>Cài đặt</MenuText>
                        <MenuArrow/>
                    </Menu>
                </MenuGroup>
            </Menus>
        </Container>
    );
}
